/* eslint-disable react/jsx-props-no-spreading */
// We have to use props spreading because of React Router's history, match and params via props.
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuthContext } from "contexts/useAuthContext";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES } from "i18n";

// const HomeRedirect = () => <Navigate to="/" />;

const UnprotectedRoute: React.FC = ({ children }) => {
  const isLoggedIn = useAuthContext();
  const { search } = useLocation();
  const { i18n } = useTranslation();

  // Set locale based on URL param
  useEffect(() => {
    const urlParams = new URLSearchParams(search); // Not support IE
    const localeParam: string | null = urlParams.get("locale");

    if (localeParam && SUPPORTED_LOCALES.includes(localeParam)) {
      i18n.changeLanguage(localeParam);
    }
  }, [search, i18n]);

  if (isLoggedIn) return <Navigate to="/" />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default UnprotectedRoute;
